import "./headingTitle.css";

function HeadingTitle(props) {
  return <h3 id="headingTitle">{props.title}</h3>;
}

export default HeadingTitle;
